import React from 'react';
import { useLanguage } from '../../contexts';
import { Language } from '../../types/quiz';

const languages: { code: Language; label: string; dir: string }[] = [
  { code: 'fr', label: 'FR', dir: 'ltr' },
  { code: 'en', label: 'EN', dir: 'ltr' },
  { code: 'ar', label: 'ع', dir: 'rtl' },
];

const LanguageSelector: React.FC = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="flex items-center gap-1 bg-white rounded-full shadow px-2 py-1">
      {languages.map((lang) => (
        <button
          key={lang.code}
          onClick={() => setLanguage(lang.code)}
          className={`px-3 py-1 rounded-full text-sm font-semibold transition-all ${
            language === lang.code
              ? 'bg-scaleo-blue text-white'
              : 'text-gray-500 hover:text-scaleo-blue'
          }`}
        >
          {lang.label}
        </button>
      ))}
    </div>
  );
};

export default LanguageSelector;
